import * as api from 'Api/endpoints';
import { Topology } from 'Consts/types';

import type { RootState, Action } from 'State/store';
import { createStandardSlice } from '../utils';

const slice = createStandardSlice<Topology>('topology');

const fetchData = (): Action => {
  return async (dispatch, getState) => {
    const { activeLocation } = getState().locations;
    const customerId = activeLocation?.customerId;
    const { data: token } = getState().locations.activeLocation
      ?.accessedAsCoAdminLocation
      ? getState().auth.coAdminData
      : getState().auth.data;
    const cloud = getState().auth.cloud;
    const topologyData = getState().topology;

    if (
      topologyData.isLoading ||
      !customerId ||
      !token ||
      !activeLocation?.id
    ) {
      return;
    }

    dispatch(actions.isLoading(true));

    const { data, error } = await api.getForceGraph({
      customerId,
      locationId: activeLocation.id,
      token,
      cloud,
    });

    if (error || !data) {
      dispatch(
        actions.error(
          error?.message || 'Error fetching topology forceGraph data'
        )
      );

      return;
    }

    dispatch(actions.set(data));
  };
};

export const selectors = (state: RootState) => state.topology;

export const actions = {
  ...slice.actions,
  fetchData,
};

export default slice.reducer;
